import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getLangFromPath } from '../../router/langRoutes';

/**
 * Component tự động đồng bộ ngôn ngữ từ URL path
 * Đọc tiền tố ngôn ngữ từ URL và cập nhật i18n nếu khác với ngôn ngữ hiện tại
 */
export default function LangRouteHandler({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const { i18n } = useTranslation();

  useEffect(() => {
    const langFromPath = getLangFromPath(location.pathname);
    
    // Nếu URL có tiền tố ngôn ngữ và khác với ngôn ngữ hiện tại
    if (langFromPath && langFromPath !== i18n.language) {
      i18n.changeLanguage(langFromPath);
      localStorage.setItem('language', langFromPath);
    }
  }, [location.pathname, i18n]);

  return <>{children}</>;
}